import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';

import { resultsConfigSelector } from 'ctm-selectors';
import { pageContext } from 'ctm-util-functions';

import styles from './sort_results.css';

/**
 * Sorting bar component
 * @returns {Node} a single anchor that sorts the results object.
 */
class _SortResults extends Component {

    /**
     * A simple object that makes it easy to toggle the methods
     * @type {{asc: string, desc: string}}
     */
    static sortDirToggle = {
        asc: 'desc',
        desc: 'asc'
    };

    constructor(props, context) {
        super(props, context);
        // setup default sort based on provided sort direction
        this.state = {
            sortDir: props.dataProps.sortDir
        };
    }

    /**
     * @todo Convert to an action creator
     * Dispatch an action that changes the sort direction based on data attributes.
     * @param {Object} event The target element event object.
     */
    handleSort = (event) => {
        const { sortDir } = this.state;
        const { dataProps, dispatch } = this.props;
        const { sortBy, sortType } = dataProps;

        dispatch({
            type: 'SORT_RESULTS',
            verticalStateKey: pageContext.getVertical(),
            sortDir,
            sortBy,
            sortType
        });

        this.setState((state) =>  {
            const nextSortDirection = _SortResults.sortDirToggle[state.sortDir];
            return { sortDir: nextSortDirection };
        });
    };

    /**
     * This is just a POC component for toggling sorting order.
     * @returns {Node} Individual Sort Bar cell
     */
    render = () => {
        const { visualProps, contentProps, dataProps, stateProps } = this.props;
        const visualPropsObj = visualProps || {};
        const contentPropsObj = contentProps || {};
        const { sortDir } = this.state;
        const { disableSorting } = dataProps;
        let variant = visualPropsObj.variant || 'sortbar_link';
        if (disableSorting) {
            // so we don't show a hand / pointer cursor when there's no sorting available
            variant = `${variant}_no_sort`;
        }
        const isActive = stateProps.sortBy === dataProps.sortBy;
        const arrowClass = (isActive && variant.indexOf('sortbar_link') !== -1) ? styles[`variant_${sortDir}_block_arrow`] : null;
        const activeClass = isActive ? styles.sort_active : null;
        const wrapperClassName = classNames(styles.root, styles[variant], arrowClass, activeClass);
        const dataId = `resultsSort.${contentPropsObj.label.replace(/ /g, '')}.${sortDir}`;

        const anchorProps = {
            href: 'javascript:;',
            'data-id': dataId,
            className: styles[`anchor_variant_${variant}`]
        };

        if (!disableSorting) {
            anchorProps.onClick = this.handleSort.bind(this);
        }

        return (
            <div className={wrapperClassName}>
                <a {...anchorProps}>
                    {contentPropsObj.label}
                </a>
            </div>
        );
    };

}

_SortResults.propTypes = {
    dispatch: PropTypes.func.isRequired,
    contentProps: PropTypes.object,
    dataProps: PropTypes.shape({
        sortBy: PropTypes.string,
        sortType: PropTypes.string,
        sortDir: PropTypes.oneOf(['asc', 'desc']),
        disableSorting: PropTypes.bool
    }),
    stateProps: PropTypes.shape({
        sortBy: PropTypes.string
    }),
    visualProps: PropTypes.shape({
        variant: PropTypes.string
    })
};

const mapStateToProps = (state) => {
    const sortingConfig = resultsConfigSelector(state).get('sorting');
    return {
        stateProps: {
            sortBy: sortingConfig.get('sortBy')
        }
    };
};

const SortResults = connect(mapStateToProps)(_SortResults);

export { SortResults };
